import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsComponent } from './settings/settings.component';
import { SettingsRoutingModule } from './settings-routing-module';
import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { SettingsHeaderComponent } from './settings-header/settings-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { SettingsDataComponent } from './settings-data/settings-data.component';
import { SettingsDataTableComponent } from './settings-data-table/settings-data-table.component';

import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [SettingsComponent, SettingsHeaderComponent, SettingsDataComponent, SettingsDataTableComponent],
  imports: [
    CommonModule,
    SettingsRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
  ],
})
export class SettingsModule {}
